var lib_core = require("lib-core");
var ui_extensions = require("ui-extensions");

var InspectorModel = function (editorModel, inspectorSubjectModel, options) {
    ui_extensions.AbstractUIModel.apply(this);
    var self = this;
    this.editorModel = editorModel;
    this.inspectorSubjectModel = inspectorSubjectModel;

    this.options = options;

    this.visible  = this.value("visible", true);
    this.focus = this.value("focus", true);
    this.draggable = this.value("draggable", true); // TODO: is this user customizable, if not this shouldn't be a model field
    this.location = this.value("location", true);
    this.readOnly = this.value('readOnly', true);

    this.location("top right");

    if(this.options) {
        if(this.options.draggable) this.draggable(this.options.draggable);
        if(this.options.location) this.location(this.options.location);
        if(this.options.read_only) this.readOnly(this.options.read_only);
    }

    this.onInit("init", this.initialize);
    
};
lib_core.inherit(InspectorModel, ui_extensions.AbstractUIModel);
lib_core.JsonParser.registerClass(InspectorModel, "InspectorModel");

module.exports = InspectorModel;

InspectorModel.prototype.initialize = function () {
    var self = this;

    var inspectorSubjects = this.inspectorSubjectModel.getInspectorSubjects();

    var updateShown = function (forceRedraw) {
        var hideState = false;
        if(self.options.hideStateRegexp) {
            if(self.options.hideStateRegexp.test(self.editorModel.state()))
                hideState = true;
        }
        if(!hideState && inspectorSubjects.size() !== 0) {
            if(forceRedraw) self.visible(false);
            self.visible(true);
        } else
            self.visible(false);
    };

    inspectorSubjects.onRemove('removeFromSelection', function () { updateShown(true); },10);
    inspectorSubjects.onAdd('addToSelection', function () { updateShown(true); }, 10);
    updateShown(true);

    // inspector can be hidden in some states
    this.editorModel.state.onChange("stateChanged", function () {
        updateShown(false);
    }, 10);

    if (this.inspectorSubjectModel.selectedSubElement) {
        this.inspectorSubjectModel.selectedSubElement.onChange('subelementChanged',
            function () {
                updateShown(true);
            }, 10);
    }
};
